const lang = {
  FR: 'fr',
  GB: 'en'
}

export default lang
